import React, { useContext, useEffect, useState } from 'react';
import './SelectPaymentScreen.css';
import axios from "axios";
import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Typography,
} from '@material-ui/core';
import { useStyles } from '../styles';
import Logo from '../components/Logo';
import { Button, CircularProgress, Dialog, DialogTitle } from '@material-ui/core';
import { setPaymentType, generateQrCode, getCheckoutUrl, setOrderType, setCustomerId, updateCustomer } from '../actions';
import { Store } from '../Store';
import config, { merchantCode } from '../util';
import { ORDER_SET_SCHEDULE_DATE } from '../constants';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import SignUp from './SignUp';
import Pickup from '../assets/image/pickup.webp';
import hh2 from '../assets/image/pngtree-coffee-delivery-motorcycle-circle-retro-cycle-graphic-delivery-vector-picture-image_9850269.png'
import hh3 from '../assets/image/th.jpg';
import Delivery from '../assets/image/delivery.webp';
import SDelivery from '../assets/image/delivery.webp';
import PlaceAutocomplete from '../components/PlaceAutocomplete';


export default function HomeScreen(props) {
  const { state, dispatch } = useContext(Store);
  let { userInfo } = state.userData;
  let customerInfo = sessionStorage.getItem("customerInfo");
  if (customerInfo) {
    customerInfo = JSON.parse(customerInfo);
  }
  const styles = useStyles();
  const { selectedCurrency, order, qr } = state;


  const [userName, setUserName] = useState(customerInfo?.customer?.firstName || "");
  const [userLName, setUserLName] = useState(customerInfo?.customer?.lastName || "");
  const [number, setNumber] = useState(customerInfo?.customer?.phone || "");
  const [email, setEmail] = useState(customerInfo?.customer?.email || "");
  const [schedule, setSchedule] = useState("");
  const [address, setAddress] = useState(customerInfo && customerInfo?.customer?.address || "");
  const [useCurrentLocation, setUseCurrentLocation] = useState(false);
  const [isLoadingLocation, setIsLoadingLocation] = useState(false);
  const [timeError, setTimeError] = useState("");
  const [addressInputMethod, setAddressInputMethod] = useState("manual");

  const [openForm, setOpenForm] = useState(true);
  const [openSign, setOpenSign] = useState(false);
  const [isPickUp, setIsPickUp] = useState(true);
  const [isDeliver, setIsDeliver] = useState(false);
  const [isScheduleDelivery, setIsScheduleDelivery] = useState(false);

  let userData = localStorage.getItem("userInfo") ? JSON.parse(localStorage.getItem("userInfo")) : null;
  let loggedUser = sessionStorage.getItem("customerInfo") ? JSON.parse(sessionStorage.getItem("customerInfo")) : null;

  let { setting } = state.userSetting;
  console.log(setting);
  if (!setting) {
    setting = JSON.parse(localStorage.getItem("userInfo"));
  }
  const selectHandler = (orderType) => {
    setOrderType(dispatch, orderType);
    setIsPickUp(false);
    setIsDeliver(false);
    setIsScheduleDelivery(false);

    if (orderType === "Pick Up") {
      setOpenForm(true);
      setIsPickUp(true);
    } else if (orderType === "Schedule Delivery") {
      setOpenForm(true);
      setIsScheduleDelivery(true);
    } else {
      setOpenForm(true);
      setIsDeliver(true);
    }
  };

  useEffect(() => {
    console.log('---selelct--');
    console.log(loggedUser);
    if (loggedUser && loggedUser.customer) {
      //setCustomerId(dispatch, loggedUser.customer.id);
      // props.history.push('/order?' + window.location.href.split('?')[1]);
    } else {
      setOpenSign(true);
    }
  }, []);


  // if (setting) {
  //   setTimeout(() => {
  //     let textcolor = document.getElementById("title1");
  //     if (textcolor) {
  //       textcolor.style.color = '#d4a017'; // Gold accent
  //     }
  //   }, 10);
  // }

  let sokURL = window.location.href.indexOf('localhost') > 0 ? 'https://online.menulive.in' : window.location.origin;
  const baseURL = config.baseURL;
  const payURL = "https://pay.digitallive24.com";

  const getCurrency = userInfo ? userInfo.currency : "";
  const getPercent = setting ? setting.taxPercent : "";

  const [qrDetails, setQrDetails] = useState([]);

  const handleCancel = () => {
    setOpenForm(false);
    setIsPickUp(false);
    setIsDeliver(false);
    setIsScheduleDelivery(false);
    setAddress("");
    setNumber("");
    setUserName("");
    setUserLName("");
    setSchedule("");
    setUseCurrentLocation(false);
    return props.history.push('/?' + window.location.href.split('?')[1]);
  };

  const updateUserAddr = (lat, long) => {
    axios.put(`${config.authapi}/customer/${customerInfo.customer.id}`, {
      lat: lat,
      long: long,
      merchantCode: merchantCode,
    }).then(res => {
      console.log(res);
      customerInfo.customer.lat = lat;
      customerInfo.customer.long = long;
      sessionStorage.setItem("customerInfo", JSON.stringify(customerInfo));
    });
  };

  const getCurrentLocation = () => {
    console.log("######## GETTING CURRENT LOCATION ####################");
    if (navigator.geolocation) {
      setIsLoadingLocation(true);
      navigator.geolocation.getCurrentPosition(
        (position) => {
          console.log(position);
          const { latitude, longitude } = position.coords;
          console.log(`Current Location (${latitude}, ${longitude})`);
          setAddress(`Current Location (${latitude}, ${longitude})`);
          setIsLoadingLocation(false);
          updateUserAddr(latitude, longitude);
        },
        (error) => {
          console.error("Error getting location:", error);
          console.log("Unable to get your current location. Please enter address manually.");
          setIsLoadingLocation(false);
          setAddressInputMethod("manual");
        },
        { enableHighAccuracy: true, timeout: 15000, maximumAge: 0 }
      );
    } else {
      console.log("Geolocation is not supported by this browser.");
      setAddressInputMethod("manual");
    }
  };

  const handleAddressMethodChange = (method) => {
    setAddressInputMethod(method);
    if (method === "current") {
      getCurrentLocation();
    }
  };

  const handleCurrentLocationChange = (e) => {
    const checked = e.target.checked;
    setUseCurrentLocation(checked);
    if (checked) {
      getCurrentLocation();
    }
  };

  const validateTime = (dateTimeString) => {
    if (!dateTimeString) return "Please select a time";

    const selectedDate = new Date(dateTimeString);
    const selectedHour = selectedDate.getHours();
    const selectedMinute = selectedDate.getMinutes();

    if (selectedHour < userInfo?.openTime || selectedHour > userInfo?.closeTime) {
      return "Please select time while it is open!";
    }

    return "";
  };

  const handleScheduleChange = (e) => {
    const newSchedule = e.target.value;
    setSchedule(newSchedule);
  };

  const handleSubmit = () => {
    if (!number || !/^\d{10,15}$/.test(number.replace(/\D/g, ''))) {
      alert("Please enter a valid phone number (10-15 digits)");
      return;
    }
    let items = [];
    console.log(order);
    let metadata = {};

    if (isPickUp) {
      metadata['schedule'] = schedule;
    } else {
      metadata['delivery'] = JSON.stringify(loggedUser.customer.email);
    }

    let eComOrdData = {
      items: items,
      metadata: metadata,
      email: loggedUser.customer.email,
      currency: "USD"
    };

    localStorage.setItem('runningOrder', JSON.stringify(eComOrdData));
    if (customerInfo) {
      customerInfo.customer.firstName = userName;
      customerInfo.customer.lastName = userLName;
      customerInfo.customer.phone = number;
      customerInfo.customer.email = email;
      customerInfo.customer.address = address;
      sessionStorage.setItem('customerInfo', JSON.stringify(customerInfo));
      updateCustomer(dispatch, customerInfo.customer.id, customerInfo.customer);
    }
    setOpenForm(false);

    return props.history.push('/order?' + window.location.href.split('?')[1]);
  };

  return (
    <Box style={{ textAlign: "center", height: "100vh", backgroundColor: setting.themeColor }}>
      {openSign && !loggedUser && (
        <Dialog open={true} fullWidth >
          <SignUp log={true} setOpenSign={setOpenSign} procedToCheckoutHandler={() => window.location.reload()} />
        </Dialog>
      )}
      <Dialog
        aria-labelledby="max-width-dialog-title"
        open={openForm}
        fullWidth={true}
        PaperProps={{
          style: {
            overflow: 'hidden',
            backgroundColor: "transparent",
            overflowY: "auto",
            scrollbarWidth: "thin"
          }
        }}
      >
        <DialogTitle >
          <div style={{
            fontSize: "1.5em",
            fontWeight: "600",
            borderBottom: "none",
            color: '#fff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontFamily: setting.themePrimaryFontFam,
            marginBottom: "20px"
          }}>
            {"Let us know more"}
          </div>
        </DialogTitle>

        <div
          style={{
            maxHeight: "100vh"
          }}
        >

          {isPickUp && (
            <div style={{ fontFamily: setting.themeSecondaryFontFam, color: setting.themeTxtColor, marginBottom: "20px", marginTop: "10px" }}>
              <span style={{ marginRight: "8px", fontSize: "18px" }}>⏰</span>
              {userData?.openTime && (
                <span style={{ color: setting.themeTxtColor }}>
                  <strong>Note:</strong> Pickup time is between {userData?.openTime} to {userData?.closeTime} O'clock.
                </span>
              )}
            </div>
          )}

          {isScheduleDelivery && (
            <div style={{
              marginBottom: "20px",
              backgroundColor: '#3a2a1a',
              border: "1px solid #8B4513",
              borderRadius: "8px",
              padding: "12px 16px",
              color: "#d4a017",
              fontSize: "0.95em",
              display: "flex",
              alignItems: "center",
              fontFamily: "'Poppins', sans-serif",
            }}>
              <span style={{ marginRight: "8px", fontSize: "18px" }}>⏰</span>
              <span><strong>Note:</strong> Schedule your delivery time between 10 AM and 6 PM.</span>
            </div>
          )}

          <span>
            <label style={{
              fontWeight: "600",
              display: "block",
              margin: "8px",
              fontSize: "1em",
              color: "#6f6d6d",
              marginTop: "10px"
            }}>
              Name <span style={{ color: "red" }}>*</span>
            </label>
            <input
              className='userInput'
              placeholder='Name'
              defaultValue={userName}
              type='text'
              onChange={(e) => setUserName(e.target.value)}
              style={{
                backgroundColor: "#2a2a2a",
                color: "#6f6d6d",
                fontFamily: setting.themeSecondaryFontFam
              }}
            />
          </span>
          {<span>
            <label style={{
              fontWeight: "600",
              display: "block",
              margin: "8px",
              fontSize: "1em",
              color: "#6f6d6d",
              fontFamily: setting.themeSecondaryFontFam

            }}>
              Last Name
            </label>
            <input
              className='userInput'
              placeholder='Last Name'
              defaultValue={userLName}
              type='text'
              onChange={(e) => setUserLName(e.target.value)}
              style={{
                backgroundColor: "#2a2a2a",
                color: "#6f6d6d",
                fontFamily: setting.themeSecondaryFontFam
              }}
            />
          </span>}
          <span>
            <label style={{
              fontWeight: "600",
              display: "block",
              margin: "8px",
              fontSize: "1em",
              color: "#6f6d6d",
              fontFamily: setting.themeSecondaryFontFam

            }}>
              Phone No. {isDeliver || isScheduleDelivery && <span style={{ color: "red" }}>*</span>}
            </label>
            <input
              type='text'
              pattern="^(\+91[\-\s]?)?[0]?(91)?[6789]\d{9}$"
              className='userInput'
              defaultValue={number}
              placeholder='Mobile No'
              maxlength={11}
              onChange={(e) => setNumber(e.target.value)}
              style={{
                backgroundColor: "#2a2a2a",
                color: "#6f6d6d",
                fontFamily: setting.themeSecondaryFontFam
              }}
            />
          </span>

          <span>
            <label style={{
              fontWeight: "600",
              display: "block",
              margin: "8px",
              fontSize: "1em",
              color: "#6f6d6d",
              fontFamily: setting.themeSecondaryFontFam

            }}>
              Email
            </label>
            <input
              type='email'
              className='userInput'
              defaultValue={email}
              placeholder='Email'
              onChange={(e) => setEmail(e.target.value)}
              style={{
                backgroundColor: "#2a2a2a",
                color: "#6f6d6d",
                fontFamily: setting.themeSecondaryFontFam
              }}
            />
          </span>
          <div style={{ animation: "fadeIn 0.3s ease" }}>
            <label style={{
              fontWeight: "600",
              display: "block",
              marginBottom: "8px",
              fontSize: "1em",
              color: "#6f6d6d",
              fontFamily: setting.themeSecondaryFontFam

            }}>
              Address {isDeliver || isScheduleDelivery && <span style={{ color: "red" }}>*</span>}
            </label>
            <PlaceAutocomplete
              placeholder='Your address'
              onPlaceSelected={(place) => {
                const newAddress = place.formatted_address || place.name || "";
                setAddress(newAddress);
              }}
              onChange={(e) => setAddress(e.target.value)}
              defaultValue={address}
              style={{
                width: "100%",
                padding: "5px",
                borderRadius: "8px",
                resize: "vertical",
                fontSize: "15px",
                transition: "border 0.2s ease",
                backgroundColor: "#2a2a2a",
                color: "#6f6d6d",
                fontFamily: setting.themeSecondaryFontFam
              }}
            />
          </div>
          {isPickUp && (
            <div style={{ marginBottom: "20px" }}>
              <label style={{
                fontWeight: "600",
                display: "block",
                margin: "8px",
                fontSize: "1em",
                color: "#6f6d6d",
                fontFamily: setting.themeSecondaryFontFam

              }}>
                Schedule <span style={{ color: "red" }}>*</span>
              </label>
              <input
                type='datetime-local'
                className='userInput'
                style={{
                  width: "100%",
                  padding: "14px",
                  borderRadius: "8px",
                  fontSize: "16px",
                  transition: "all 0.2s ease",
                  backgroundColor: "#2a2a2a",
                  color: "#6f6d6d",
                  fontFamily: setting.themeSecondaryFontFam
                }}
                onChange={handleScheduleChange}
                value={schedule}
              />
            </div>
          )}




          {isScheduleDelivery && (
            <div style={{ marginBottom: "20px" }}>
              <label style={{
                fontWeight: "600",
                display: "block",
                marginBottom: "8px",
                fontSize: "1em",

              }}>
                Schedule <span style={{ color: "red" }}>*</span>
              </label>
              <input
                type='datetime-local'
                className='userInput'
                style={{
                  width: "100%",
                  padding: "14px",
                  border: timeError ? "2px solid #ff0000" : "1px solid #8B4513",
                  borderRadius: "8px",
                  fontSize: "16px",
                  transition: "all 0.2s ease",
                  backgroundColor: '#3a2a1a',
                  color: '#fff',
                  fontFamily: "'Poppins', sans-serif",
                }}
                onChange={handleScheduleChange}
                value={schedule}
              />
              {timeError && (
                <div style={{
                  color: "#ff0000",
                  fontSize: "0.85em",
                  marginTop: "6px",
                  textAlign: "left",
                  display: "flex",
                  alignItems: "center",
                  fontFamily: "'Poppins', sans-serif",
                }}>
                  <span style={{ marginRight: "5px" }}>⚠️</span> {timeError} (Hours: 10:00 AM - 6:00 PM)
                </div>
              )}
            </div>
          )}

          <Box textAlign="center" >
            <Button
              variant="contained"
              onClick={handleSubmit}
              disabled={(isPickUp || isScheduleDelivery) && (timeError || !schedule)}
              style={{
                width: "70%",
                padding: "10px",
                backgroundColor: setting.themeTxtColor, // ✅ Fixed: single '#'
                color: setting.themeColor,
                fontFamily: setting.themeSecondaryFontFam,
                borderRadius: "8px",
                fontWeight: "bold",
              }}
            >
              {"NEXT"}
            </Button>
          </Box>


        </div>
      </Dialog>

      <Box style={{ height: '100vh!important', backgroundColor: setting.themeColor, padding: "20px" }}>
        
        <h2 style={{
          color: setting.themeTxtColor,
          fontFamily: setting.themePrimaryFontFam,
          fontWeight: 700,
          marginBottom: '30px',
        }}>
          How'd you like to collect order?
        </h2>
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: '15px',
        }}>
          <Card
            xs={1}
            sm={2}
            className={styles.card}
            style={{
              width: '150px',
              margin: '10px',
              backgroundColor: '#2a2a2a',
              borderRadius: '12px',
              boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
              transition: 'transform 0.3s ease',
              position: 'relative'
            }}
            onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
            onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
          >
            <CardActionArea onClick={() => selectHandler('Pick Up')} style={{ height: '100%' }}>
              <CardMedia
                component="img"
                image={Pickup}
                className={styles.media}
                style={{ height: "166px", width: "140px", margin: "0 auto" }}
              />
              <CardContent style={{ padding: '5px', height: '50px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Typography
                  gutterBottom
                  variant="h4"
                  color="textPrimary"
                  component="p"
                  style={{
                    margin: 0,
                    fontSize: "1.2rem",
                    color: setting.themeTxtColor,
                    fontFamily: setting.themePrimaryFontFam,
                    fontWeight: 600,
                  }}
                >
                  PICK UP
                </Typography>
              </CardContent>
            </CardActionArea>
            {isPickUp && <CheckCircleIcon style={{ position: 'absolute', top: 5, left: 5, color: '#4CAF50', zIndex: 10, fontSize: "30px", pointerEvents: 'none' }} />}
          </Card>

          <Card
            xs={1}
            sm={2}
            className={styles.card}
            style={{
              width: '150px',
              margin: '10px',
              backgroundColor: '#2a2a2a',
              borderRadius: '12px',
              boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
              transition: 'transform 0.3s ease',
              position: 'relative'
            }}
            onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
            onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
          >
            <CardActionArea onClick={() => selectHandler('Delivery')} id='counter' style={{ height: '100%' }}>
              <CardMedia
                component="img"
                alt="Delivery"
                image={hh2}
                className={styles.media}
                style={{ height: "166px", width: "140px", margin: "0 auto" }}
              />
              <CardContent style={{ padding: '5px', height: '50px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Typography
                  gutterBottom
                  variant="h4"
                  color="textPrimary"
                  component="p"
                  style={{
                    margin: 0,
                    fontSize: "1.2rem",
                    color: setting.themeTxtColor,
                    fontFamily: setting.themePrimaryFontFam,
                    fontWeight: 600,
                  }}
                >
                  DELIVERY
                </Typography>
              </CardContent>
            </CardActionArea>
            {isDeliver && <CheckCircleIcon style={{ position: 'absolute', top: 5, left: 5, color: '#4CAF50', zIndex: 10, fontSize: "30px", pointerEvents: 'none' }} />}
          </Card>

          <Card
            xs={1}
            sm={2}
            className={styles.card}
            style={{
              width: '150px',
              margin: '10px',
              backgroundColor: '#2a2a2a',
              borderRadius: '12px',
              boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
              transition: 'transform 0.3s ease',
              position: 'relative'
            }}
            onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
            onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
          >
            <CardActionArea onClick={() => selectHandler('Schedule Delivery')} style={{ height: '100%' }}>
              <CardMedia
                component="img"
                alt="Schedule Delivery"
                image={hh3}
                className={styles.media}
                style={{ height: "166px", width: "140px", margin: "0 auto" }}
              />
              <CardContent style={{ padding: '5px', height: '50px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Typography
                  gutterBottom
                  variant="h4"
                  color="textPrimary"
                  component="p"
                  style={{
                    margin: 0,
                    fontSize: "1.2rem",
                    color: setting.themeTxtColor,
                    fontFamily: setting.themePrimaryFontFam,
                    fontWeight: 600,
                  }}
                >
                  SCHEDULE DELIVERY
                </Typography>
              </CardContent>
            </CardActionArea>
            {isScheduleDelivery && <CheckCircleIcon style={{ position: 'absolute', top: 5, left: 5, color: '#4CAF50', zIndex: 10, fontSize: "30px", pointerEvents: 'none' }} />}
          </Card>
        </div>
      </Box>
    </Box>

  );
}